import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconCancel from '@material-ui/icons/Cancel'
import EditIcon from '@material-ui/icons/Edit'
import { useState } from 'react'
import { Button, FormWithRedirect, SaveButton, useNotify, useRefresh } from 'react-admin'

import { editAssignedDriverOrTruck } from '../../../api/jobs'
import { JOB_ACTIVE_STATUSES } from '../../../helpers/constants'
import { captureExceptionIfProduction, getReadableErrorMessage } from '../../../helpers/utils'
import { withDisableBackdropClick } from '../../../helpers/withDisableBackdropClick'
import { Job } from '../../../models/jobs'
import { AssignedDriverReferenceInput } from '../../Fields'

interface EditAssignedDriverButtonProps {
  job: Job
  iconColor?: string
}

export function EditAssignedDriverButton({ job, iconColor }: EditAssignedDriverButtonProps) {
  const [showDialog, setShowDialog] = useState(false)
  const [loading, setLoading] = useState(false)

  const notify = useNotify()
  const refresh = useRefresh()
  const handleClick = () => setShowDialog(true)
  const handleClose = () => setShowDialog(false)

  const handleSubmit = async (values: any) => {
    setLoading(true)
    editAssignedDriverOrTruck(job.id, values)
      .then(() => {
        setShowDialog(false)
        setLoading(false)
        notify('Success!', { type: 'info' })
        refresh()
      })
      .catch((error) => {
        setLoading(false)
        const stringified = getReadableErrorMessage(error)
        notify(`${error.message}: ${stringified}`, {
          type: 'error',
        })
        captureExceptionIfProduction(error)
      })
  }

  if (!JOB_ACTIVE_STATUSES.includes(job?.status)) {
    return null
  }

  return (
    <>
      <Button onClick={handleClick}>
        <EditIcon htmlColor={iconColor} />
      </Button>
      <Dialog
        fullWidth
        open={showDialog}
        onClose={withDisableBackdropClick(handleClose)}
        aria-label="Assign driver"
      >
        <DialogTitle>Assign driver</DialogTitle>
        <FormWithRedirect
          resource="assigned_to"
          save={handleSubmit}
          render={({ handleSubmitWithRedirect, saving }) => (
            <>
              <DialogContent>
                <AssignedDriverReferenceInput contactedLoadTeamId={job.team?.id} />
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleClose} disabled={loading}>
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={handleSubmitWithRedirect}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  )
}
